import { NotifyErrorWrapper, NotifyFail, NotifySuccess, NotifySuccessWrapper } from '@/helpers/core/notifications'
import { bulkDeleteHostedMiners, getHostedMiners, refreshHostedMiners } from '@/services/hvl/hosted-miners.service'
import type { IHostedMinerFilters } from '@/types/hvl/filters'
import type { AdminPortalAPIError } from '@/types/shared/errors'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import type { Reactive } from 'vue'

export const useHostedMiners = () => {
  const client = useQueryClient()

  const getHostedMinersQuery = (filters: Reactive<IHostedMinerFilters>) =>
    useQuery({
      queryKey: ['hosted-miners', filters],
      queryFn: () => getHostedMiners(filters),
    })

  const refreshHostedMinersMutation = useMutation({
    mutationFn: () => refreshHostedMiners(),
    onError: (e: AdminPortalAPIError) => {
      if (e.status === 429) {
        NotifyFail('You can only refresh hosted miners once per minute')
      } else {
        NotifyFail(e.message)
      }
    },
    onSuccess: NotifySuccessWrapper(`Refresh command sent.`),
  })

  const bulkDeleteHostedMinersMutation = useMutation({
    mutationFn: (id: number[]) => bulkDeleteHostedMiners(id),
    onError: NotifyErrorWrapper('Failed to delete miners'),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['hosted-miners'] })
      NotifySuccess(`Miners deleted successfully`)
    },
  })

  return {
    getHostedMinersQuery,
    refreshHostedMinersMutation,
    bulkDeleteHostedMinersMutation,
  }
}
